<template>
    <div class="w-full">
        <div class="w-full border h-[260px] relative shadow-sm"
            :class="{ 'border border-danger border-dashed': error, ' border-gray-300': !error }">
            <a target="_blank" v-if="!qrcreate.text.content"
                :href="useRuntimeConfig().public.app_user_url + '/page-builder'"
                class="text-sm text-gray-300 absolute top-3 right-4 hidden md:block">
                {{ $t('advanced_editor') }}
            </a>
            <textarea v-if="!qrcreate.imageData" @click="error = false" v-model="text"
                class="w-full resize-none outline-none px-4 py-3 h-[258px]" :placeholder="dataLocales.data.placeholder"
                :class="{ 'placeholder-danger': error }"></textarea>
            <div v-else class="flex h-full w-full bg-white items-center justify-center text-center">
                {{ qrcreate.text.content }}
            </div>
        </div>
        <ToolsButtonCreate @generate="generate" />
    </div>
</template>
<script lang="ts" setup>
import { useQrCreateStore } from "~/stores/qrcreate"
import DataLocale from "~~/config/interface/DataLocale"
const text = ref('')
const error = ref(false)
const qrcreate = useQrCreateStore()
const qrstyle = useQrStyle()
const validateData = () => {
    if (text.value) {
        qrcreate.text.content = text.value
        return true
    }
    error.value = true;
    return false;
}
const generate = async () => {
    if (validateData()) {
        await qrstyle.GenerateQrCode({stack:true})
    }
}

const dataLocales = new DataLocale([
    {
        locale: "en",
        placeholder: "Please enter text content",
    },
    {
        locale: "vi",
        placeholder: "Vui lòng nhập nội dung văn bản",
    },
    {
        locale: "de",
        placeholder: "Bitte geben Sie den Textinhalt ein",
    },
    {
        locale: "fr",
        placeholder: "Veuillez entrer le contenu du texte",
    },
    {
        locale: "es",
        placeholder: "Por favor ingrese el contenido del texto",
    },
    {
        locale: "it",
        placeholder: "Inserisci il contenuto del testo",
    },
    {
        locale: "pt",
        placeholder: "Por favor insira o conteúdo do texto",
    },
    {
        locale: "ja",
        placeholder: "テキストコンテンツを入力してください",
    },
    {
        locale: "zh",
        placeholder: "请输入文本内容",
    },
    {
        locale: "nl",
        placeholder: "Voer tekstinhoud in",
    }
])

</script>